<template>
  <ConfigErrorBoundary>
    <FileConverter :config="converterConfig" @batch-created="handleBatchCreated" @job-completed="handleJobCompleted" @batch-cleared="handleBatchCleared" @error="handleError" @credits-updated="handleCreditsUpdated" />
  </ConfigErrorBoundary>
</template>
<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';
const converterConfig = parseAndValidateConverterConfig('arw-to-webp-converter', 'Sony ARW → WebP');
function handleBatchCreated(batchId: string) { console.log('[ARW to WebP] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[ARW to WebP] Job completed:', jobId); }
function handleBatchCleared() { console.log('[ARW to WebP] Batch cleared'); }
function handleError(error: Error) { console.error('[ARW to WebP] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[ARW to WebP] Credits updated:', credits); }
</script>
